import Markdown from 'markdown-to-jsx'
import { useRouter } from 'next/router'
import React from 'react'

import BackButton from '@/legacy-src/components/button/BackButton'
import EllipsisIcon from '@/legacy-src/components/header/EllipsisIcon'
import Icon from '@/legacy-src/components/icons/Icon'
import { Button } from '@/legacy-src/components/ui/button'
import { useApis } from '@/legacy-src/contexts/api-context'
import useProcessSuccessfulLogin from '@/legacy-src/hooks/useProcessSuccessfulLogin'
import colors from '@/legacy-src/rebrand/colors'
import { getTranslate } from '@/legacy-src/utilities/i18n'
import Toaster from '@/legacy-src/utilities/toaster'

import { useLoginParams } from '@/src/domains/auth/hooks/useLoginParams'

const DoubledAccount = () => {
  const router = useRouter()
  const { next } = useApis()
  const { t } = getTranslate()
  const processLogin = useProcessSuccessfulLogin()
  const { query } = router

  const { therapistId, diagnosis, kind, socialUser, user } = router.query as Record<string, any>
  const { redirectUrl } = useLoginParams()

  const handleBackToLogin = () => {
    delete router.query.kind
    delete router.query.socialUser
    return router.replace({ query: { ...router.query } })
  }

  const handleCreateNewAccount = async () => {
    const regex = /companyEmployee\[email\]=([^&]+)/
    const companyEmail = decodeURIComponent(router.asPath).match(regex)?.[1]

    // user is passed via query as string
    const appleUser = user && user !== 'undefined' ? JSON.parse(user) : {}
    console.log(kind, appleUser, 'appleUser')
    try {
      const response = await next.registerFromSocial({
        ...(query['companyEmployee[token]']
          ? {
              companyEmployee: {
                slug: query['companyEmployee[slug]'],
                companyEmail: companyEmail,
                activationLinkId: query['companyEmployee[activationLinkId]'],
                blinkClientId: query['companyEmployee[blinkClientId]'],
                token: query['companyEmployee[token]'],
                code: query['companyEmployee[code]'],
              },
            }
          : {}),
        user: kind === 'apple' ? appleUser : undefined,
        socialUser,
      })

      processLogin({
        response,
        redirectUrl,
        email: companyEmail,
        therapistId: Number.parseInt(therapistId, 10),
        diagnosis,
        sendEvent: response.status !== 201,
      })
    } catch (err) {
      Toaster.error('errors.defaultError')
      console.log('double account error', err)
    }
  }

  return (
    <div className="fixed bottom-0 left-0 z-20 h-full w-full bg-black bg-opacity-30 tablet:static tablet:bg-transparent">
      <div className="mt-[47px] h-full rounded-3xl bg-white p-5 tablet:p-12">
        <div className="mb-8 block text-sm tablet:hidden">
          <BackButton
            text={t('component.doubledAccount.backToLogin')}
            size="xxs"
            onClick={handleBackToLogin}
            icon="back"
          />
        </div>

        <div className="flex flex-col items-center justify-center text-center">
          <EllipsisIcon color={colors.yellow[500]} className="mb-4 shrink-0 tablet:mb-6">
            <Icon icon="warning-rebrand" color="secondary" size="lg" width={30} height={30} />
          </EllipsisIcon>

          <h3 className="mb-4">{t('component.doubledAccount.headline')}</h3>
          <Markdown className="mb-6 text-sm">{t('component.doubledAccount.description')}</Markdown>
          <Button onClick={handleBackToLogin} className="mb-3 w-full" size="medium">
            {t('component.doubledAccount.backToLogin')}
          </Button>
          <Button onClick={handleCreateNewAccount} variant="light" className="w-full" size="medium">
            {t('component.doubledAccount.createAccount')}
          </Button>
        </div>
      </div>
      <div className="flex flex-col gap-3 py-5 text-sm">
        <div className="flex items-center">
          <Icon icon="mobile-phone" color="primary" size="sm" className="mr-3" />
          <Markdown>{t('registration.onlyPassword')}</Markdown>
        </div>
        <div className="flex items-center">
          <Icon icon="lock" color="primary" size="sm" className="mr-3" />
          <Markdown>{t('registration.lock')}</Markdown>
        </div>
      </div>
    </div>
  )
}

export default DoubledAccount
